import { setLogLevel } from '@ms/yammer-console-logging';
import { ReportErrorOptions, reportError, reportInfo } from '@ms/yammer-data/dist/telemetry';
import { ErrorCode, getBrowserInfo } from '@ms/yammer-telemetry';
import { getUrlRootPath } from '@ms/yammer-web-support/dist/location';

import config from '../../config';

export const reportBootstrapStarted: VoidFunction = () => {
  reportInfo({
    eventName: 'bootstrap_started',
    eventProperties: {
      ...getBrowserInfo(),
      urlRootPath: getUrlRootPath(location.pathname),
    },
  });
};

export const reportErrorWithCode: (error: ReportErrorOptions['error'], errorCode: ErrorCode) => void = (
  error,
  errorCode
) => {
  reportError({ error, eventProperties: { errorCode } });
};

export const setupLogging: VoidFunction = () => {
  setLogLevel(config.logging.logLevel);
};
